module.exports = __webpack_public_path__ + "img/bw.9145c2d2.svg";